// extracted by mini-css-extract-plugin
export default {"image":"j1-z","loaded":"k1-z"};